import React, { useState } from 'react';
import { FormField, Select } from 'grommet';



export const CreateOption = (props) => {
  const [value, setValue] = useState(props.values);
  return (
      <FormField name='department_ids' label='Department' margin='xsmall'>
        <Select
        margin='small'
          name='department_ids'
          multiple
          closeOnChange={false}
          size="medium"
          placeholder="Select"
          labelKey={'name'}
          valueKey={'id'}
          value={value}
          options={props.departments}
          onChange={({ value: nextValue }) => setValue(nextValue)}
        />
        </FormField>
  );
};